import React, { useRef, useState } from 'react';

import { Grid, Typography, Paper } from '@material-ui/core';

import TableGeneric from '../../compartidos/abms/TableGeneric';
import { CustomDivider } from '../atoms/Divider';
import { ButtonGeneric } from '../atoms/Buttons';
import { GenericCheckboxTable } from '../organisms/GenericTable';

export const TemplateMultiList = ({ templateLists }) => {
    const componentRef = useRef();

    const [selectedStates, setSelectedStates] = useState(
        templateLists.map(() => [])
    );

    const updateSelected = (index, selectedData) => {
        const newSelectedStates = [...selectedStates];
        newSelectedStates[index] = selectedData;
        setSelectedStates(newSelectedStates);
    };
    
    return (
        <Grid component={Paper} elevation={2} container spacing={1}>
            {templateLists.map(({ title, checkBox }, index) => {
                const currentDataList = templateLists[index].list;
                const currentColumns = templateLists[index].columns;
                const selected = selectedStates[index];

                return (
                    <Grid key={index} component={Paper} elevation={2} item xs={12} md={4}>
                        <Grid container justify='center'>
                            <Grid item xs={12} style={{textAlign: 'center', padding: '0.5em'}}>
                                <Typography variant='button'>{title}</Typography>
                            </Grid>
                            <CustomDivider />
                            <Grid item xs={12}>
                                {!!checkBox ? (
                                    <GenericCheckboxTable 
                                        ref={componentRef}
                                        align="center"
                                        data={currentDataList}
                                        columns={currentColumns}
                                        setSelected={selectedData => {
                                            const newSelectedStates = [...selectedStates];
                                            newSelectedStates[index] = selectedData;
                                            setSelectedStates(newSelectedStates);
                                        }}
                                        selected={selected}
                                        withoutPagination
                                    />
                                ) : (
                                    <TableGeneric 
                                        ref={componentRef}
                                        align="center"
                                        data={currentDataList}
                                        columns={currentColumns}
                                        withoutPagination
                                    />
                                )}
                            </Grid>
                            {!!checkBox && (
                                <ButtonGeneric 
                                    type="button"
                                    style={{ borderRadius: 0 }}
                                    fullWidth
                                    text={checkBox.text}
                                    onClick={() => { checkBox.onClick(selected, (selectedData) => updateSelected(index, selectedData)) }}
                                    disabled={selected.length === 0}
                                />
                            )}
                        </Grid>
                    </Grid>
                )
            })}
        </Grid>
    )
}
